import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";


export const addContactus = async (data) => {
  try {
    return await postData(`/website/contactus/add`, data);
  } catch (error) {
    console.log(error);
  }
};


export const addFarmDealEnquiry = async (data) => {
  try {
    return await postData(`/website/farmer-dealer/add`, data);
  } catch (error) {
    console.log(error);
  }
};


export const getAppSetup = async () => {
  try {
    return await getData(`/website/footer/appsetup`);
  } catch (error) {
    console.log(error);
  }
};


export const getSocialMedia = async () => {
  try {
    return await getData(`/website/homepage/socialmedia`);
  } catch (error) {
    console.log(error);
  }
};